import { render, staticRenderFns } from "./comp-audio.vue?vue&type=template&id=494e6c34&scoped=true&lang=pug"
import script from "./comp-audio.vue?vue&type=script&lang=js"
export * from "./comp-audio.vue?vue&type=script&lang=js"
import style0 from "./comp-audio.vue?vue&type=style&index=0&id=494e6c34&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494e6c34",
  null
  
)

export default component.exports